import RequestStatus from "../model/RequestStatus";
import { 
    FeeTypeName, 
    FeeTypeExampleData, 
    FeeTypeExampleVersionData,
    CreateFeeTypeExampleRequest, 
    UpdateFeeTypeExampleRequest,
    ActivateFeeTypeExampleVersionRequest
} from "src/model/FeeTypeExample";

// Fee Type Names Actions
export const FETCH_FEE_TYPE_NAMES_START = 'FETCH_FEE_TYPE_NAMES_START';
export const FETCH_FEE_TYPE_NAMES_SUCCESS = 'FETCH_FEE_TYPE_NAMES_SUCCESS';
export const FETCH_FEE_TYPE_NAMES_FAILED = 'FETCH_FEE_TYPE_NAMES_FAILED';

// Fee Type Example Query Actions
export const FETCH_FEE_TYPE_EXAMPLE_START = 'FETCH_FEE_TYPE_EXAMPLE_START';
export const FETCH_FEE_TYPE_EXAMPLE_SUCCESS = 'FETCH_FEE_TYPE_EXAMPLE_SUCCESS';
export const FETCH_FEE_TYPE_EXAMPLE_FAILED = 'FETCH_FEE_TYPE_EXAMPLE_FAILED';

// Fee Type Example Save Actions
export const SAVE_FEE_TYPE_EXAMPLE_START = 'SAVE_FEE_TYPE_EXAMPLE_START';
export const SAVE_FEE_TYPE_EXAMPLE_SUCCESS = 'SAVE_FEE_TYPE_EXAMPLE_SUCCESS';
export const SAVE_FEE_TYPE_EXAMPLE_FAILED = 'SAVE_FEE_TYPE_EXAMPLE_FAILED';

// Fee Type Example Create Actions
export const CREATE_FEE_TYPE_EXAMPLE_START = 'CREATE_FEE_TYPE_EXAMPLE_START';
export const CREATE_FEE_TYPE_EXAMPLE_SUCCESS = 'CREATE_FEE_TYPE_EXAMPLE_SUCCESS';
export const CREATE_FEE_TYPE_EXAMPLE_FAILED = 'CREATE_FEE_TYPE_EXAMPLE_FAILED';

// Fee Type Example Delete Actions
export const DELETE_FEE_TYPE_EXAMPLE_START = 'DELETE_FEE_TYPE_EXAMPLE_START';
export const DELETE_FEE_TYPE_EXAMPLE_SUCCESS = 'DELETE_FEE_TYPE_EXAMPLE_SUCCESS';
export const DELETE_FEE_TYPE_EXAMPLE_FAILED = 'DELETE_FEE_TYPE_EXAMPLE_FAILED';

// Fee Type Example Versions Actions
export const FETCH_FEE_TYPE_EXAMPLE_VERSIONS_START = 'FETCH_FEE_TYPE_EXAMPLE_VERSIONS_START';
export const FETCH_FEE_TYPE_EXAMPLE_VERSIONS_SUCCESS = 'FETCH_FEE_TYPE_EXAMPLE_VERSIONS_SUCCESS';
export const FETCH_FEE_TYPE_EXAMPLE_VERSIONS_FAILED = 'FETCH_FEE_TYPE_EXAMPLE_VERSIONS_FAILED';

// Activate Version Actions
export const ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_START = 'ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_START';
export const ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_SUCCESS = 'ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_SUCCESS';
export const ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_FAILED = 'ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_FAILED';

// UI State Actions
export const SET_SELECTED_FEE_TYPE = 'SET_SELECTED_FEE_TYPE';
export const SHOW_FEE_TYPE_MODAL = 'SHOW_FEE_TYPE_MODAL';
export const HIDE_FEE_TYPE_MODAL = 'HIDE_FEE_TYPE_MODAL';

// Fee Type Names Action Interfaces
export interface FetchFeeTypeNamesStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
}

export interface FetchFeeTypeNamesCompleteAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly data: FeeTypeName[] | null;
}

// Fee Type Example Query Action Interfaces
export interface FetchFeeTypeExampleStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly feeType: string;
}

export interface FetchFeeTypeExampleCompleteAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly data: FeeTypeExampleData | null;
}

// Fee Type Example Save Action Interfaces
export interface SaveFeeTypeExampleStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly request: UpdateFeeTypeExampleRequest;
}

export interface SaveFeeTypeExampleCompleteAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly data: FeeTypeExampleData | null;
    readonly error?: string;
}

// Fee Type Example Create Action Interfaces
export interface CreateFeeTypeExampleStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly request: CreateFeeTypeExampleRequest;
}

export interface CreateFeeTypeExampleCompleteAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly data: FeeTypeExampleData | null;
    readonly error?: string;
}

// Fee Type Example Delete Action Interfaces
export interface DeleteFeeTypeExampleStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly feeType: string;
}

export interface DeleteFeeTypeExampleCompleteAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly error?: string;
}

// Fee Type Example Versions Action Interfaces
export interface FetchFeeTypeExampleVersionsStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly feeType: string;
}

export interface FetchFeeTypeExampleVersionsCompleteAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly data: FeeTypeExampleVersionData[] | null;
}

// Activate Version Action Interfaces
export interface ActivateFeeTypeExampleVersionStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly request: ActivateFeeTypeExampleVersionRequest;
}

export interface ActivateFeeTypeExampleVersionCompleteAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly data: FeeTypeExampleData | null;
    readonly error?: string;
}

// UI State Action Interfaces
export interface SetSelectedFeeTypeAction {
    readonly type: string;
    readonly selectedFeeType: string;
}

export interface ShowFeeTypeModalAction {
    readonly type: string;
    readonly modalType: 'delete' | 'versions' | 'create';
}

export interface HideFeeTypeModalAction {
    readonly type: string;
}

// Fee Type Names Action Creators
export const fetchFeeTypeNamesStart = (): FetchFeeTypeNamesStartAction => ({
    type: FETCH_FEE_TYPE_NAMES_START,
    requestStatus: RequestStatus.LOADING,
});

export const fetchFeeTypeNamesSuccess = (data: FeeTypeName[]): FetchFeeTypeNamesCompleteAction => ({
    type: FETCH_FEE_TYPE_NAMES_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    data: data
});

export const fetchFeeTypeNamesFailed = (): FetchFeeTypeNamesCompleteAction => ({
    type: FETCH_FEE_TYPE_NAMES_FAILED,
    requestStatus: RequestStatus.ERROR,
    data: null
});

// Fee Type Example Query Action Creators
export const fetchFeeTypeExampleStart = (feeType: string): FetchFeeTypeExampleStartAction => ({
    type: FETCH_FEE_TYPE_EXAMPLE_START,
    requestStatus: RequestStatus.LOADING,
    feeType: feeType
});

export const fetchFeeTypeExampleSuccess = (data: FeeTypeExampleData): FetchFeeTypeExampleCompleteAction => ({
    type: FETCH_FEE_TYPE_EXAMPLE_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    data: data
});

export const fetchFeeTypeExampleFailed = (): FetchFeeTypeExampleCompleteAction => ({
    type: FETCH_FEE_TYPE_EXAMPLE_FAILED,
    requestStatus: RequestStatus.ERROR,
    data: null
});

// Fee Type Example Save Action Creators
export const saveFeeTypeExampleStart = (request: UpdateFeeTypeExampleRequest): SaveFeeTypeExampleStartAction => ({
    type: SAVE_FEE_TYPE_EXAMPLE_START,
    requestStatus: RequestStatus.UPDATING,
    request: request
});

export const saveFeeTypeExampleSuccess = (data: FeeTypeExampleData): SaveFeeTypeExampleCompleteAction => ({
    type: SAVE_FEE_TYPE_EXAMPLE_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    data: data
});

export const saveFeeTypeExampleFailed = (error: string): SaveFeeTypeExampleCompleteAction => ({
    type: SAVE_FEE_TYPE_EXAMPLE_FAILED,
    requestStatus: RequestStatus.ERROR,
    data: null,
    error: error
});

// Fee Type Example Create Action Creators
export const createFeeTypeExampleStart = (request: CreateFeeTypeExampleRequest): CreateFeeTypeExampleStartAction => ({
    type: CREATE_FEE_TYPE_EXAMPLE_START,
    requestStatus: RequestStatus.UPDATING,
    request: request
});

export const createFeeTypeExampleSuccess = (data: FeeTypeExampleData): CreateFeeTypeExampleCompleteAction => ({
    type: CREATE_FEE_TYPE_EXAMPLE_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    data: data
});

export const createFeeTypeExampleFailed = (error: string): CreateFeeTypeExampleCompleteAction => ({
    type: CREATE_FEE_TYPE_EXAMPLE_FAILED,
    requestStatus: RequestStatus.ERROR,
    data: null,
    error: error
});

// Fee Type Example Delete Action Creators
export const deleteFeeTypeExampleStart = (feeType: string): DeleteFeeTypeExampleStartAction => ({
    type: DELETE_FEE_TYPE_EXAMPLE_START,
    requestStatus: RequestStatus.UPDATING,
    feeType: feeType
});

export const deleteFeeTypeExampleSuccess = (): DeleteFeeTypeExampleCompleteAction => ({
    type: DELETE_FEE_TYPE_EXAMPLE_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
});

export const deleteFeeTypeExampleFailed = (error: string): DeleteFeeTypeExampleCompleteAction => ({
    type: DELETE_FEE_TYPE_EXAMPLE_FAILED,
    requestStatus: RequestStatus.ERROR,
    error: error
});

// Fee Type Example Versions Action Creators
export const fetchFeeTypeExampleVersionsStart = (feeType: string): FetchFeeTypeExampleVersionsStartAction => ({
    type: FETCH_FEE_TYPE_EXAMPLE_VERSIONS_START,
    requestStatus: RequestStatus.LOADING,
    feeType: feeType
});

export const fetchFeeTypeExampleVersionsSuccess = (data: FeeTypeExampleVersionData[]): FetchFeeTypeExampleVersionsCompleteAction => ({
    type: FETCH_FEE_TYPE_EXAMPLE_VERSIONS_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    data: data
});

export const fetchFeeTypeExampleVersionsFailed = (): FetchFeeTypeExampleVersionsCompleteAction => ({
    type: FETCH_FEE_TYPE_EXAMPLE_VERSIONS_FAILED,
    requestStatus: RequestStatus.ERROR,
    data: null
});

// Activate Version Action Creators
export const activateFeeTypeExampleVersionStart = (request: ActivateFeeTypeExampleVersionRequest): ActivateFeeTypeExampleVersionStartAction => ({
    type: ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_START,
    requestStatus: RequestStatus.UPDATING,
    request: request
});

export const activateFeeTypeExampleVersionSuccess = (data: FeeTypeExampleData): ActivateFeeTypeExampleVersionCompleteAction => ({
    type: ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    data: data
});

export const activateFeeTypeExampleVersionFailed = (error: string): ActivateFeeTypeExampleVersionCompleteAction => ({
    type: ACTIVATE_FEE_TYPE_EXAMPLE_VERSION_FAILED,
    requestStatus: RequestStatus.ERROR,
    data: null,
    error: error
});

// UI State Action Creators
export const setSelectedFeeType = (selectedFeeType: string): SetSelectedFeeTypeAction => ({
    type: SET_SELECTED_FEE_TYPE,
    selectedFeeType: selectedFeeType
});

export const showFeeTypeModal = (modalType: 'delete' | 'versions' | 'create'): ShowFeeTypeModalAction => ({
    type: SHOW_FEE_TYPE_MODAL,
    modalType: modalType
});

export const hideFeeTypeModal = (): HideFeeTypeModalAction => ({
    type: HIDE_FEE_TYPE_MODAL
});
